<template>
  <div class="list-wrap">
    <el-card class="list-body">
      <!-- 顶部按钮区域 -->
      <el-row class="common-con-btns mb10">
        <el-button size="small" type="primary" class="fresh-btn" @click="fresh">刷新</el-button>
        <!-- <el-button size="small" type="primary" class="fresh-btn" @click="exportFeedBack">导出</el-button> -->
      </el-row>
      <!-- 筛选区域 -->
      <el-form :inline="true" :model="search" ref="searchForm" size="mini">
        <!-- <el-form-item
          :rules="[{ min:16,max:16, message: '请填写16位的防伪码',trigger: 'blur'}]"
          label="筛选"
          prop="security_code"
        >
          <el-input
            class="select-input"
            placeholder="防伪码"
            size="mini"
            v-model="search.security_code"
          ></el-input>
        </el-form-item>-->

        <el-form-item>
          <el-input class="select-input" placeholder="用户id" size="mini" v-model="search.ac_id"></el-input>
        </el-form-item>
        <el-form-item>
          <!-- :rules="[{ min:11,max:11, message: '请填写11位的手机号',trigger: 'blur'}]"
          prop="phone"-->
          <el-input class="select-input" placeholder="联系电话" size="mini" v-model="search.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="select-input" placeholder="店铺id" size="mini" v-model="search.shop_id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="search.shop_name"
            filterable
            remote
            v-loadmore="loadSearchTagTerm"
            reserve-keyword
            placeholder="店铺名称"
            :remote-method="remoteMethod"
            @click.native="remoteMethod(false)"
          >
            <el-option v-for="(item,index) in shopOptions" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="反馈类型" class="feedback-select" v-model="search.category">
            <!-- <el-option value label="反馈类型"></el-option> -->
            <el-option :value="1" label="门店倒闭"></el-option>
            <el-option :value="2" label="商家拒绝兑换"></el-option>
            <el-option :value="3" label="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSearch" size="mini" type="primary">筛选</el-button>
          <el-button @click="onReset" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域 -->
      <el-table
        :data="dataList"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="listTable"
        ref="listTable"
        style="width: 100%"
      >
        <el-table-column label="用户id" prop="ac_id"></el-table-column>
        <el-table-column label="微信昵称" prop>
          <template slot-scope="scope">
            <span
              @click="toCodeDetail(scope.row)"
              class="underline blue cursor"
            >{{scope.row.user.nickname}}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系电话" prop="phone"></el-table-column>
        <el-table-column label="用户反馈类型">
          <template slot-scope="scope">
            <span v-if="scope.row.category == 1">门店倒闭</span>
            <span v-else-if="scope.row.category == 2">商家拒绝兑换</span>
            <span v-else-if="scope.row.category == 3">其他</span>
          </template>
        </el-table-column>

        <el-table-column label="店铺id" prop="shop_id"></el-table-column>
        <el-table-column label="店铺名称" prop="shop_name"></el-table-column>
        <el-table-column label="店主联系方式" prop>
          <template slot-scope="scope">
            <span>{{scope.row.shop.contacts_mobile}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="备注" prop="remark"></el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="showRemark(scope.row)" size="mini" type="text">{{'备注'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          :page-size="page.pageSize"
          :total="page.total"
          @current-change="onChangePage"
          background
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 备注 -->
    <el-dialog :visible.sync="remark.show" title="备注" width="500px">
      <el-form :model="remark" label-width="80px" ref="remarkForm">
        <el-form-item :rules="{required: true, message: '请填写备注内容'}" label="备注内容" prop="note">
          <el-input type="textarea" v-model="remark.note"></el-input>
        </el-form-item>
      </el-form>
      <!-- <div class="dialog-footer ftc" slot="footer">
        <el-button @click="onRemark" type="primary">确认</el-button>
        <el-button @click="remark.show = false">取消</el-button>
      </div>-->
    </el-dialog>
    <viewMedia :imglist="viewMedia" ref="viewPicture"></viewMedia>
  </div>
</template>

<script>
import viewMedia from "@/components/common/viewMedia";
import { feedbackApi } from "@/api/feedback/";
import lodash from "lodash";

export default {
  components: {
    viewMedia
  },
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 50,
        total: 0
      },
      shopOptions: [],
      losdMoreObj: {
        per_page: 10,
        current_page: 1,
        loading: false
      },
      viewMedia: [],
      search: {
        ac_id: "",
        phone: "",
        category: "",
        shop_id: "",
        shop_name: ""
      },
      dataList: [],
      remark: {
        id: "",
        note: "",
        show: false
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList(page) {
      const params = {
        page: this.page.currentPage,
        per_page: this.page.pageSize,
        ...this.search
      };
      return this.$EpetJs.Common.get(feedbackApi.getHeFeedBackUrl, params, {
        needLoading: true
      }).then(res => {
        if (res) {
          this.dataList = res.data.data;
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total;
            this.page.currentPage = res.data.meta.pagination.current_page;
          }
        }
        return res;
      });
    },
    //刷新
    fresh() {
      this.getList();
    },
    // //导出
    // exportFeedBack() {
    //   const params = {
    //     ...this.search
    //   };
    //   this.$EpetJs.Common.get(feedbackApi.exportFeedBackUrl, params).then(
    //     res => {
    //       if (res) {
    //         this.$message.success("操作成功，请去导出列表查看！");
    //       }
    //     }
    //   );
    // },
    /**
     * remark dialog
     */
    showRemark(row) {
      this.remark = {
        id: row.id,
        show: true,
        note: row.content ? row.content : ""
      };
      this.$nextTick(() => {
        this.$refs["remarkForm"].clearValidate();
      });
    },
    /**
     * 提交备注
     */
    // onRemark() {
    //   return this.$refs["remarkForm"].validate(async valid => {
    //     if (!valid) return;
    //     const params = {
    //       id: this.remark.id,
    //       remark: this.remark.note
    //     };
    //     await this.$EpetJs.Common.put(
    //       feedbackApi.addHeRemark + this.remark.id + "/remark",
    //       params,
    //       {
    //         needLoading: true
    //       }
    //     ).then(res => {
    //       if (res) {
    //         this.dataList = res.data.data;
    //         if (res.data.meta && res.data.meta.pagination) {
    //           this.page.total = res.data.meta.pagination.total;
    //         }
    //         this.$message.success("成功！");
    //         this.remark.show = false;
    //       }
    //       return res;
    //     });
    //     await this.getList();
    //   });
    // },
    /**跳转用户列表 */
    toCodeDetail(row) {
      this.$router.push({
        path: "/client_user/list",
        query: {
          ac_id: row.ac_id
        }
      });
    },
    /**
     * 当前页改变
     */
    onChangePage(val) {
      this.page.currentPage = val;
      this.getList(val);
    },
    /**
     * 筛选
     */
    onSearch() {
      this.page.currentPage = 1;
      // this.$refs["searchForm"].validate(valid => {
      // if (!valid) return;
      this.getList();
      // });
    },
    // 查看附件
    showMedia(img) {
      this.viewMedia = [{ url: img }];
      this.$refs.viewPicture.showViewPicture = true;
    },
    /**
     * 重置
     */
    onReset() {
      this.search = {
        ac_id: "",
        phone: "",
        category: "",
        shop_id: "",
        shop_name: ""
      };
      this.page.currentPage = 1;
      this.getList();
    },
    /**
     *  店铺名称联想搜索
     * @param queryString 输入的值
     */
    remoteMethod(queryString) {
      this.search.shop_name = queryString ? queryString : "";
      this.$EpetJs.Common.ajax("get", feedbackApi.getShopList, {
        name: queryString ? queryString : "",
        per_page: this.losdMoreObj.per_page,
        current_page: 1
      }).then(res => {
        if (res) {
          console.log(res.data.data);
          this.shopOptions = res.data.data;
        }
      });
    },
    //滚动加载筛选区域分类维度
    loadSearchTagTerm() {
      if (!this.losdMoreObj.loading) {
        this.losdMoreObj.loading = true;
        this.losdMoreObj.current_page++;
        const pam = {
          name: this.search.shop_name,
          per_page: this.losdMoreObj.per_page,
          current_page: this.losdMoreObj.current_page
        };
        this.$EpetJs.Common.ajax("get", feedbackApi.getShopList, pam).then(
          res => {
            if (res) {
              if (res.data.data.length == 0) {
                this.losdMoreObj.loading = true;
                return false;
              }
              this.shopOptions = this.shopOptions.concat(res.data.data);
              setTimeout(() => {
                this.losdMoreObj.loading = false;
              }, 1000);
            }
          }
        );
      }
    }
  }
};
</script>
<style lang="less">
.select-input,
.feedback-select {
  width: 110px;
}
.list-wrap {
  .blue {
    color: #409eff;
  }
  .list-body {
    min-height: calc(100vh - 60px);
    .delete-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
    .detail-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
</style>